import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-20 bg-white" data-id="element-14">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-16">
          {/* Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-17">
            <div className="aspect-[3/4] w-full max-w-md mx-auto lg:mx-0 relative group overflow-hidden shadow-xl" data-id="element-18">
              <img src="https://cdn.magicpatterns.com/uploads/tBBEPHKFoQYHszBuVHVQQW/FreddieCheah.jpg" alt="Freddie Cheah, Owner and Chef" className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" data-id="element-19" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" data-id="element-20"></div>
            </div>
            {/* Decorative accent */}
            <div className="absolute -bottom-4 -left-4 w-32 h-32 border-b-2 border-l-2 border-amber/30 -z-10 hidden lg:block" data-id="element-21"></div>
          </motion.div>

          {/* Text */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-center lg:text-left" data-id="element-22">
            <span className="text-amber font-medium tracking-widest uppercase text-sm mb-3 block" data-id="element-23">
              Our Story
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-8" data-id="element-24">
              Welcome to Freddie Cheah
            </h2>

            <div className="space-y-6 text-gray-600 leading-relaxed text-lg" data-id="element-25">
              <p data-id="element-26">
                Nestled in the historic brick buildings of Paducah, Freddie
                Cheah brings a fresh perspective to Asian fusion cuisine. We
                believe in honoring traditional techniques while embracing local
                ingredients and modern flavor profiles.
              </p>
              <p data-id="element-27">
                Whether you're joining us for a quick lunch, a celebratory
                dinner, or cocktails at our bar, our warm atmosphere and
                carefully crafted menu are designed to make every visit
                memorable.
              </p>
            </div>

            <div className="mt-8" data-id="element-28">
              <div className="w-16 h-1 bg-warm-brown mx-auto lg:mx-0" data-id="element-29"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}